import React, { useState } from "react";
import withStyles from '@mui/styles/withStyles';
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import KyteTecRegistrationModal from "./KyteTecRegistrationModal";
import KyteTecEmailRegistrationModal from "./KyteTecEmailRegistrationModal";
import KyteTecInfoModal from "./KyteTecInfoModal";

const styles = (theme) => ({});

function NotKyteTecMemeberModal({
  classes,
  setShowPurchaseModal,
  setShowKyteTecRegistrationModal,
  showKyteTecRegistrationModal,
  currentUser,
  couponCode,
  discount
}) {
  useMakeScrollable('scrollable')
  const [showKyteTecEmailModal, setShowKyteTecEmailModal] = useState(false);
  const [showKyteTecInfoModal, setShowKyteTecInfoModal] = useState(false);

  return (
    <div id="model-container" className="scrollable">
      {showKyteTecRegistrationModal && (
        <KyteTecRegistrationModal
          setShowPurchaseModal={setShowPurchaseModal}
          setShowKyteTecRegistrationModal={setShowKyteTecRegistrationModal}
          setShowKyteTecEmailModal={setShowKyteTecEmailModal}
          setShowKyteTecInfoModal={setShowKyteTecInfoModal}
          currentUser={currentUser}
          couponCode={couponCode}
          discount={discount}
          classes={classes}
        />
      )}
      {showKyteTecEmailModal && (
        <KyteTecEmailRegistrationModal
          setShowKyteTecEmailModal={setShowKyteTecEmailModal}
          setShowPurchaseModal={setShowPurchaseModal}
          classes={classes}
          currentUser={currentUser}
        />
      )}
      {showKyteTecInfoModal && (
        <KyteTecInfoModal
          setShowPurchaseModal={setShowPurchaseModal}
          setShowKyteTecInfoModal={setShowKyteTecInfoModal}
          classes={classes}
        />
      )}
    </div>
  );
}

export default withStyles(styles())(NotKyteTecMemeberModal);
